import { render, staticRenderFns } from "./OnboardingTip.vue?vue&type=template&id=1e6ca53e&scoped=true"
import script from "./OnboardingTip.vue?vue&type=script&lang=js"
export * from "./OnboardingTip.vue?vue&type=script&lang=js"
import style0 from "./OnboardingTip.vue?vue&type=style&index=0&id=1e6ca53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6ca53e",
  null
  
)

export default component.exports